const COUNTRY_TO_LANG: Record<string, string> = {
  BR: 'pt',
  PT: 'pt-PT',
  AO: 'pt-PT',
  MZ: 'pt-PT',
  US: 'en',
  GB: 'en',
  CA: 'en',
  AU: 'en',
  ES: 'es',
  MX: 'es',
  AR: 'es',
  CO: 'es',
  CL: 'es',
  PE: 'es',
  FR: 'fr',
  DE: 'de',
  AT: 'de',
  CH: 'de',
  CN: 'zh',
  TW: 'zh',
  HK: 'zh',
  JP: 'ja',
  KR: 'ko',
  SA: 'ar',
  AE: 'ar',
  EG: 'ar',
  IT: 'it',
};

const DEFAULT_LANG = 'en';

export async function detectLanguageFromGPS(): Promise<string | null> {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=3`
          );
          const data = await response.json();

          if (data?.address?.country_code) {
            const countryCode = data.address.country_code.toUpperCase();
            const lang = COUNTRY_TO_LANG[countryCode];
            if (lang) {
              console.log(`GPS detected country: ${countryCode}, setting language to: ${lang}`);
              resolve(lang);
              return;
            }
          }
          resolve(null);
        } catch (e) {
          console.warn('GPS Reverse geocoding failed', e);
          resolve(null);
        }
      },
      (error) => {
        console.warn('Geolocation permission denied or failed', error);
        resolve(null);
      },
      { timeout: 8000 }
    );
  });
}

export async function detectFromIP(): Promise<string> {
  try {
    const response = await fetch('https://ipwho.is/');
    const data = await response.json();

    if (data.success && data.country_code) {
      const countryCode = data.country_code;
      const lang = COUNTRY_TO_LANG[countryCode];
      if (lang) {
        console.log(`IP detected country: ${countryCode}, setting language to: ${lang}`);
        return lang;
      }
    }
  } catch (e) {
    console.error('IP Geolocation failed', e);
  }

  console.log('Geolocation failed or country not supported, defaulting to:', DEFAULT_LANG);
  return DEFAULT_LANG;
}
